import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  flex-direction: column;

  label {
    display: block;
    margin-bottom: 10px;
    color: #101d40;
    font-weight: 500;
    font-size: 14px;
    font-family: 'Sora', sans-serif;
  }
`;

export const TextAreaContainer = styled.div`
  display: flex;
  flex: 1;

  textarea {
    resize: none;
    width: 100%;
    border-radius: 5px;
    border: 2px solid #e6effb;
    padding: 10px 10px 10px 14px;
    color: #101d40;
    font-size: 13px;
    font-family: 'Sora', sans-serif;
    transition: all 0.2s ease-in-out;

    &:focus {
      border-color: #329bfc;
    }

    &:hover:not(:focus) {
      border-color: #96cdff;
    }
  }
`;
